// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-card-actions[data-v-9897a770]{display:flex}.w-card-actions div[data-v-9897a770]{display:flex;align-items:center}.w-card-actions div[data-v-9897a770]:not(:first-child):before{content:\"·\";display:flex;padding:0 5px}.w-card-actions .w-button-like.v-btn[data-v-9897a770]{width:22px;height:22px;margin-left:2px;margin-right:-5px}", ""]);
// Exports
module.exports = exports;
